var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "exam typeing" }, [
    _c("div", { staticClass: "nuv" }, [
      _c(
        "a",
        { staticClass: "active", attrs: { href: "/tjkStudy/examlist" } },
        [_vm._v("考试中心")]
      ),
      _vm._v(">"),
      _c("span", [_vm._v(_vm._s(_vm.data.examName))])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "left" }, [
      _c("div", { staticClass: "exam-con" }, [
        _c("h2", [_vm._v(_vm._s(_vm.data.examName))]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content typing-con" },
          [
            _vm._l(_vm.paperlist, function(l, key) {
              return [
                _c("p", {
                  staticClass: "row-con",
                  domProps: { innerHTML: _vm._s(l.lastcontent) }
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: l.input,
                      expression: "l.input"
                    }
                  ],
                  staticClass: "typing-input",
                  attrs: { maxlength: l.maxlength, onpaste: "return false" },
                  domProps: { value: l.input },
                  on: {
                    keyup: function($event) {
                      return _vm.computeFun(key, $event)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(l, "input", $event.target.value)
                    }
                  }
                })
              ]
            })
          ],
          2
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "right" }, [
      _c("div", { staticClass: "count" }, [
        _c("h2", [_vm._v("统计")]),
        _vm._v(" "),
        _c("div", { staticClass: "useTime" }, [
          _c("p", [_vm._v("距自动交卷时间")]),
          _vm._v("jingmai\n        "),
          _c("span", { staticClass: "blue" }, [_vm._v(_vm._s(_vm.time))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "useTime" }, [
          _c("p", { staticClass: "txt" }, [
            _vm._v("速度：" + _vm._s(_vm.lastspeed) + "字/分")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "useTime" }, [
          _c("p", { staticClass: "txt" }, [
            _vm._v("正确率：" + _vm._s(_vm.ratio) + "%")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "useTime" }, [
          _c("p", { staticClass: "txt" }, [
            _vm._v("总字数：" + _vm._s(_vm.totalNum) + "字")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "useTime" }, [
          _c("p", { staticClass: "txt" }, [
            _vm._v("错误：" + _vm._s(_vm.errorNum) + "字")
          ])
        ]),
        _vm._v(" "),
        _vm.isShowBtn == true
          ? _c("div", { staticClass: "btn" }, [
              _c(
                "div",
                { staticClass: "submit typing", on: { click: _vm.submitExam } },
                [_vm._v("提交试卷")]
              )
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c58e7a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c58e7a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/examTyping.vue
// module id = 1125
// module chunks = 0